import { Button, Result } from 'antd';
import { routes } from 'src/data/routes';
import { useNavigate } from 'react-router-dom';
export default function NotFound() {
  const navigate = useNavigate();
  return (<Result
    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={<Button type="primary" onClick={()=>navigate(routes.INVESTMENTS)} className='primary'>Back Home</Button>}
  />)
}